import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.is-array.js";

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
    label: 0,
    sent: function sent() {
      if (t[0] & 1) throw t[1];
      return t[1];
    },
    trys: [],
    ops: []
  },
      f,
      y,
      t,
      g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;

  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }

  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");

    while (_) {
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
        if (y = 0, t) op = [op[0] & 2, t.value];

        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;

          case 4:
            _.label++;
            return {
              value: op[1],
              done: false
            };

          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;

          case 7:
            op = _.ops.pop();

            _.trys.pop();

            continue;

          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }

            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }

            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }

            if (t && _.label < t[2]) {
              _.label = t[2];

              _.ops.push(op);

              break;
            }

            if (t[2]) _.ops.pop();

            _.trys.pop();

            continue;
        }

        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    }

    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};

var __values = this && this.__values || function (o) {
  var s = typeof Symbol === "function" && Symbol.iterator,
      m = s && o[s],
      i = 0;
  if (m) return m.call(o);
  if (o && typeof o.length === "number") return {
    next: function next() {
      if (o && i >= o.length) o = void 0;
      return {
        value: o && o[i++],
        done: !o
      };
    }
  };
  throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};

import { assert } from "@/common/assert";
import { STORE_SENT_MESSAGE, RECEIVE_NEW_MESSAGE, UPDATE_UNREAD_MESSAGE_COUNT, HISTORY_MESSAGES_LOADED, SAVE_MESSAGE_DRAFT } from "./Types";
export function saveMessageDraft(to, draft) {
  return {
    type: SAVE_MESSAGE_DRAFT,
    to: to,
    draft: draft
  };
}
export function storeSentMessage(message, originalMessage) {
  return {
    type: STORE_SENT_MESSAGE,
    message: message,
    originalMessage: originalMessage
  };
}
export function receiveNewMessage(message, chatId) {
  return {
    type: RECEIVE_NEW_MESSAGE,
    message: message,
    chatId: chatId
  };
}
export function updateUnreadMessageCount(lastMessage, chatId, unreadMessageCount, isFromMyself, currentContactChatId) {
  if (unreadMessageCount) {
    assert(typeof unreadMessageCount === "number", "unreadMessageCount not number");
  }

  return {
    type: UPDATE_UNREAD_MESSAGE_COUNT,
    lastMessage: lastMessage,
    chatId: chatId,
    unreadMessageCount: unreadMessageCount,
    isFromMyself: isFromMyself,
    currentContactChatId: currentContactChatId
  };
}
export function chatMessageHistoryLoaded(contact, historyMessages) {
  return {
    type: HISTORY_MESSAGES_LOADED,
    contact: contact,
    historyMessages: historyMessages
  };
}
export function loadChatMessageHistory(contact) {
  var _this = this;

  return function (dispatch, getState) {
    return __awaiter(_this, void 0, void 0, function () {
      var _a, chatClient, myself, historyMessages, err_1;

      return __generator(this, function (_b) {
        switch (_b.label) {
          case 0:
            _b.trys.push([0, 2,, 3]);

            _a = getState().imSession, chatClient = _a.chatClient, myself = _a.myself;
            assert(chatClient, "im falsy");
            assert(myself, "myself falsy");
            return [4
            /*yield*/
            , chatClient.downloadHistoryMessages(contact)];

          case 1:
            historyMessages = _b.sent();
            dispatch(chatMessageHistoryLoaded(contact, historyMessages));
            return [3
            /*break*/
            , 3];

          case 2:
            err_1 = _b.sent();
            console.error(err_1);
            return [3
            /*break*/
            , 3];

          case 3:
            return [2
            /*return*/
            ];
        }
      });
    });
  };
}
export function sendMessage(message) {
  var _this = this;

  return function (dispatch, getState) {
    return __awaiter(_this, void 0, void 0, function () {
      var chatClient, msg, msg_1, msg_1_1, m, err_2;

      var e_1, _a;

      return __generator(this, function (_b) {
        switch (_b.label) {
          case 0:
            _b.trys.push([0, 2,, 3]);

            chatClient = getState().imSession.chatClient;
            assert(chatClient, "chatClient falsy");
            return [4
            /*yield*/
            , chatClient.sendMessage(message)];

          case 1:
            msg = _b.sent();

            if (Array.isArray(msg)) {
              try {
                for (msg_1 = __values(msg), msg_1_1 = msg_1.next(); !msg_1_1.done; msg_1_1 = msg_1.next()) {
                  m = msg_1_1.value;
                  dispatch(storeSentMessage(m, message));
                }
              } catch (e_1_1) {
                e_1 = {
                  error: e_1_1
                };
              } finally {
                try {
                  if (msg_1_1 && !msg_1_1.done && (_a = msg_1["return"])) _a.call(msg_1);
                } finally {
                  if (e_1) throw e_1.error;
                }
              }
            } else {
              dispatch(storeSentMessage(msg, message));
            }

            return [3
            /*break*/
            , 3];

          case 2:
            err_2 = _b.sent();
            console.error(err_2);
            return [3
            /*break*/
            , 3];

          case 3:
            return [2
            /*return*/
            ];
        }
      });
    });
  };
}